export default {"src":"/_next/static/media/maskGroup.a3e1114b.svg","height":699,"width":960,"blurWidth":0,"blurHeight":0};